export default __webpack_public_path__ + "static/media/a028-4.4905cd8e.png";